import { Component, Input, ViewChild } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { DentComponent } from '../dent/dent.component';
import { RccTraitement } from 'src/app/service/rcc.service';
import * as pdfjsLib from 'pdfjs-dist';
import { Context } from 'src/app/shared/services/context.service';
import { ObjetService } from 'src/app/service/objet.service';
import { PdfService } from 'src/app/service/pdf.service';
@Component({
  selector: 'app-rcc',
  templateUrl: './rcc.component.html',
  styleUrls: ['./rcc.component.scss']
})
export class RccComponent {

  @Input('currentDate') currentDate;
  @Input('userSelected') userSelected;
  @Input('ageString') ageString;
  @Input('traitementRccId') traitementRccId;
  @Input('traitementRcc') traitementRcc;
  @Input('showSummary') showSummary = false;
  @Input('listRccTreatement') listRccTreatement = [];
    
  selectedTeeth: any = [];
 @ViewChild(DentComponent, { static: false }) dentComponent!: DentComponent;

  idUser: string;
dateCreation : any = null ;
  praticien: any;
  constructor(private modalController: ModalController, private rccTraitement :RccTraitement, private objetService: ObjetService,private pdfService: PdfService) {}

  objets = {
    pkObjet: 0,
    nom: "",
    extension: "",
    id_patient: 0,
    vignette: "",
    width: 0,
    height: 0,
    taille: 0,
    estidentite: 0,
    dateCreation: "",
    echelle: 0,
    fichier: "",
    lastModif: "",
    repStockage: "",
    syncPath: "",
    dateInsertion: "",
    auteur: "",
    idGabarit: "",
    id_patient_orthalis: "",
  };
  selectedOptions: string[] = [];
  selectedColor: string = '';
  remarks: string = '';
  isUrgent: boolean = false;
  isReparation: boolean = false;
  
  // Champs spécifiques
  priLength: string = '';
  priHeight: string = '';
  priOption: string = '';
  frielsTeeth: string = '';
  cantileversTeeth: string = '';
  verinTeeth: string = '';
  story: string = null;
  rccOptions = [
    { key: 'verin_median', label: 'Vérin médian' },
    { key: 'plan_molaire', label: 'Plan molaire' },
    { key: 'pri', label: 'PRI' },
    { key: 'friels', label: 'Friels' },
    { key: 'cantilevers', label: 'Cantilevers' },
    { key: 'verin_recul', label: 'Verin Recul Postérieur' },
    { key: 'grille_anti_puce', label: 'Grille Anti pouce' },
    { key: 'crochet_tim', label: 'Crochet TIM' }
  ];

  colors = [
    { name: 'Bleu', hex: '#3b82f6', textColor: 'white' },
    { name: 'Jaune', hex: '#facc15', textColor: 'black' },
    { name: 'Vert', hex: '#22c55e', textColor: 'white' },
    { name: 'Rose', hex: '#ec4899', textColor: 'white' },
    { name: 'Transp.', hex: '#f3f4f6', textColor: 'black' }
    
  ];

  // Exemple dans ton composant .ts
planMolaireSelections: string[] = [];

togglePlanMolaire(option: string) {
  const index = this.planMolaireSelections.indexOf(option);
  if (index === -1) {
    // Si non sélectionné, on l'ajoute
    this.planMolaireSelections.push(option);
  } else {
    // Si déjà sélectionné, on le retire
    this.planMolaireSelections.splice(index, 1);
  }
}

isPlanMolaireSelected(option: string): boolean {
  return this.planMolaireSelections.includes(option);
}


  ngOnInit() {
    let value = localStorage.getItem("currentUser");
    this.praticien = JSON.parse(value);
    this.idUser = localStorage.getItem("idPatient");
    console.log('this.idUser',this.idUser);

    if (this.traitementRccId) {
      // this.loadTraitement(this.traitementId);
      console.log('traitementRcc',this.traitementRcc);
      this.selectedOptions = this.traitementRcc.selectedOptions;
      this.selectedColor = this.traitementRcc.selectedColor;
      this.remarks = this.traitementRcc.remarks;
      this.dateCreation = this.traitementRcc.dateCreation;
      this.isUrgent = this.traitementRcc.isUrgent;
      this.isReparation = this.traitementRcc.isReparation;
      this.isPaillette = this.traitementRcc.isPaillette;
      this.selectedTeethMap.cantilevers= this.traitementRcc.cantileversTeeth;
      this.selectedTeethMap.friels= this.traitementRcc.frielsTeeth;
      this.selectedTeethMap.verin_recul=this.traitementRcc.verinReculTeeth;
      this.priLength=this.traitementRcc.pri.length;
      this.priHeight=this.traitementRcc.pri.height;
      this.priOption=this.traitementRcc.pri.option;
      this.frielsTeeth =  this.traitementRcc.frielsTeeth.map(t => t.numteeth).join(',');
      this.verinTeeth =  this.traitementRcc.verinReculTeeth.map(t => t.numteeth).join(',');
      this.cantileversTeeth =  this.traitementRcc.cantileversTeeth.map(t => t.numteeth).join(',');
      this.dateCreation = this.traitementRcc.dateCreation ; 
      this.planMolaireSelections = this.traitementRcc.planMolaireSelections ; 
      console.log('selectedTeethMap',this.selectedTeethMap);
      console.log('priLength',this.priLength);
      this.story = this.traitementRcc.history ; 
        }
  }
  selectTreatment(type: string) {

    this.selectedOptions = [];
    this.selectedColor = '';
    this.remarks = '';
  }

  toggleOption(key: string) {
    const index = this.selectedOptions.indexOf(key);
    if (index > -1) {
      this.selectedOptions.splice(index, 1);
    } else {
      this.selectedOptions.push(key);
    }
  }

  getSelectedOptionLabels(selectedOptions): string[] {
    return selectedOptions.map(key => {
      const match = this.rccOptions.find(option => option.key === key);
      return match ? match.label : key;
    });
  }
  

  selectColor(color: string) {
    this.selectedColor = color;
  }

  submit() {
    this.showSpinner = true;
    let x = {
      idPatient : this.idUser,
      selectedOptions: this.selectedOptions,
      selectedColor: this.selectedColor,
      remarks: this.remarks,
      pri: {
        length: this.priLength,
        height: this.priHeight,
        option: this.priOption
      },
      frielsTeeth: this.selectedTeethMap['friels'] || [],
      cantileversTeeth: this.selectedTeethMap['cantilevers'] || [],
      verinReculTeeth: this.selectedTeethMap['verin_recul'] || [],
      planMolaireSelections: this.planMolaireSelections || [],
      isUrgent: this.isUrgent,
      isReparation: this.isReparation,
      isPaillette: this.isPaillette,
      id : this.traitementRccId ,
      history : this.story ,
      dateCreation : this.dateCreation,
      typePlan: "Home Made",
      idPraticien: this.praticien.id

    }
    console.log("x",x);


    this.rccTraitement.addNewTreatments(x).subscribe((response: Blob) => {
    console.log("response : ", response );
    // this.printPlanDeTraitement();
    // this.getPlantDeTraitement(this.idUser);
    this.getListRccTreatement();
      
    });
    // this.showSummary = true;
  }


  getTeethList(type: 'friels' | 'cantilevers' | 'verin_recul'): string {
    const list = this.selectedTeethMap[type];
    return list && list.length > 0 ? list.map(t => t.numteeth).join(', ') : 'Aucune';
  }

  
  updateSelectedTeeth(teeth: any[]) {
    if (this.currentPopup) {
      this.selectedTeethMap[this.currentPopup] = teeth;
      console.log(`Dents mises à jour pour ${this.currentPopup}:`, teeth);
    }
  }

  selectedTeethMap: {
    [key: string]: any[]; // ou plus précisément : Record<string, { numteeth: string }[]>
  } = {
    friels: [],
    cantilevers: [],
    verin_recul: []
  };
  isDialogVisible = false;

  currentPopup: 'friels' | 'cantilevers' | 'verin_recul' | null = null;
  openModal(type: 'friels' | 'cantilevers' | 'verin_recul') {
    this.currentPopup = type;
    if (!this.selectedTeethMap[type]) {
      this.selectedTeethMap[type] = [];
    }
    this.isDialogVisible = true;
  
    setTimeout(() => {
      if (this.dentComponent) {
        this.dentComponent.onChangeTraitement(this.selectedTeethMap[type]);
      }
    }, 1000);
  }
  
  confirmSelectedTeeth() {
    if (this.currentPopup) {
      const teeth = this.selectedTeethMap[this.currentPopup];
      const teethStr = teeth.map(t => t.numteeth).join(',');
  
      switch (this.currentPopup) {
        case 'friels': this.frielsTeeth = teethStr; break;
        case 'cantilevers': this.cantileversTeeth = teethStr; break;
        case 'verin_recul': this.verinTeeth = teethStr; break;
      }
  
      console.log(`Teeth confirmed for ${this.currentPopup}:`, teethStr);
      this.isDialogVisible = false;
    }
  }
  
  onDialogClose() {
    this.currentPopup = null;
  }
  
  getCurrentSelectedTeeth(): any[] {
    return this.currentPopup ? this.selectedTeethMap[this.currentPopup] : [];
  }
  
  close() {
    this.currentPopup = null;
  }

  getHeader(): string {
    switch (this.currentPopup) {
      case 'friels': return 'Dents pour Friels';
      case 'cantilevers': return 'Dents pour Cantilevers';
      case 'verin_recul': return 'Dents pour Verin Recul Postérieur';
      default: return '';
    }
  }
  lastrccTraitement:any;
getListRccTreatement() {
  this.rccTraitement.getAllTreatments(this.idUser).subscribe({
    next: (response: any) => {
      this.listRccTreatement = [];
      for (let i = response.length - 1; i >= 0; i--) {
        this.listRccTreatement.push(response[i]);
      }
      this.lastrccTraitement = this.listRccTreatement[0];
      this.showSpinner = false;
      this.showSummary = true;
    },
    error: (err) => {
      console.error("Erreur dans getListRccTreatement()", err);
      this.showSpinner = false;
    }
  });
}



  pailette = { name: 'Paillettes', hex: '#c084fc', textColor: 'white' }
getButtonStyle(color: any): any {
  if (color.name === 'Paillettes') {
    return {
      'background-image': 'url("assets/pailette.jpg")',
      'background-size': 'cover',
      'color': color.textColor,
      'border': this.isPaillette ? '2px solid black' : '2px solid transparent',
      'border-radius': '10px' // optionnel pour garder cohérence visuelle
    };
  } else {
    return {
      'background-color': color.hex,
      'color': color.textColor
    };
  }
}


  printPlanDeTraitement() {
    const printElement = document.getElementById('rccResume');
    if (printElement) {
      // Afficher l'élément en retirant l'attribut hidden
      printElement.hidden = false;
  
      // Créer une fenêtre d'impression
      const printWindow = window.open('', '_blank', "width="+ screen.width + ",height=" + screen.height);
      if (printWindow) {
        printWindow.document.write(`
          <html>
            <head>
              <title>Résumé du Plan de Traitement ${this.userSelected}</title>
              <style>
                 body {
                    font-family: Arial, sans-serif;
                    margin: 0;
                    padding: 0;
                    background-color: #f9f9f9;
                    color: #333;
                  }
                  .container {
                    width: 80%;
                    margin: 20px auto;
                    background: #fff;
                    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
                    border-radius: 8px;
                    padding: 20px;
                  }
                  .header {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    margin-bottom: 20px;
                    border-bottom: 2px solid #58b3dd;
                    padding-bottom: 10px;
                  }
                  .header h1 {
                    color: #58b3dd;
                    font-size: 24px;
                    margin: 0;
                  }
                  .header .date {
                    font-size: 14px;
                    color: #777;
                  }
                  .section {
                    margin-bottom: 10px;
                    padding: 15px;
                    background-color: #f1f9ff;
                    border-left: 5px solid #58b3dd;
                    border-radius: 4px;
                  }
                  .section h2 {
                    font-size: 20px;
                    margin-bottom: 10px;
                    color: #333;
                  }
                  .section p {
                    margin: 5px 0;
                    line-height: 1.6;
                  }
                   th, td {
                  border: 1px solid #3b82f6;
                  padding: 8px;
                  text-align: center;
                  vertical-align: top;
                }
            
                th {
                  background-color: #f0f8ff;
                  font-weight: bold;
                }
            
                td {
                  white-space: pre-line;
                }
              </style>
            </head>
            <body>${printElement.outerHTML}</body>
            <script type="text/javascript" defer>
              setTimeout(function() {
                  window.print();
                  window.close();
              }, 1000);
            </script>
          </html>
        `);
      }
      printWindow.document.close();
      // Réappliquer l'attribut hidden après impression
      printElement.hidden = true;
      this.downloadAsPdf();
    } else {
      console.error('Élément à imprimer introuvable.');
    }
  }

  downloadAsPdf() {
    var printContents = document.getElementById("rccResume").innerHTML;
    let html = `
          <html>
            <head>
              <title>Résumé du Plan de Traitement ${this.userSelected}</title>
              <style>
                 body {
                    font-family: Arial, sans-serif;
                    margin: 0;
                    padding: 0;
                    background-color: #f9f9f9;
                    color: #333;
                  }
                  .container {
                    width: 80%;
                    margin: 20px auto;
                    background: #fff;
                    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
                    border-radius: 8px;
                    padding: 20px;
                  }
                  .header {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    margin-bottom: 20px;
                    border-bottom: 2px solid #58b3dd;
                    padding-bottom: 10px;
                  }
                  .header h1 {
                    color: #58b3dd;
                    font-size: 24px;
                    margin: 0;
                  }
                  .header .date {
                    font-size: 14px;
                    color: #777;
                  }
                  .section {
                    margin-bottom: 10px;
                    padding: 15px;
                    background-color: #f1f9ff;
                    border-left: 5px solid #58b3dd;
                    border-radius: 4px;
                  }
                  .section h2 {
                    font-size: 20px;
                    margin-bottom: 10px;
                    color: #333;
                  }
                  .section p {
                    margin: 5px 0;
                    line-height: 1.6;
                  }
                    th, td {
                      border: 1px solid #3b82f6;
                      padding: 8px;
                      text-align: center;
                      vertical-align: top;
                    }
                
                    th {
                      background-color: #f0f8ff;
                      font-weight: bold;
                    }
                
                    td {
                      white-space: pre-line;
                    }
              </style>
            </head>
            <body>${printContents}</body>
            <script type="text/javascript" defer>
              setTimeout(function() {
                  window.print();
              }, 1000);
            </script>
          </html>
        `;

          
    this.pdfService.htmlToPdf(html).subscribe((response: Blob) => {
      const blob = new Blob([response], { type: 'application/pdf' });
      this.saveToBasePhoto(blob);
    });
  }
  isDisabled: boolean = false;
  showSpinner: boolean = false;
  async saveToBasePhoto(blob: any) {
    // const arrayBuffer = await blob.arrayBuffer();
    // const destName = sha1(blob.text());
    const destName = "Rcc_" + localStorage.getItem('idPatient') + generateRandomString(12);

    pdfjsLib.GlobalWorkerOptions.workerSrc = "https://cdn.jsdelivr.net/npm/pdfjs-dist@2.6.347/build/pdf.worker.min.js";
    const pdfDoc = await pdfjsLib.getDocument({ url: URL.createObjectURL(blob) }).promise.then(async (pdf) => {
      const page = await pdf.getPage(1);
      const canvas = document.createElement('canvas');
      const context = canvas.getContext("2d");
      const viewport = page.getViewport({ scale: 1 });
      canvas.width = viewport.width;
      canvas.height = viewport.height;
      const renderContext = {
        canvasContext: canvas.getContext('2d'),
        viewport: viewport,
      };
      await page.render(renderContext).promise.then( async () => {
        const imageDataURL = canvas.toDataURL('image/jpeg', 25);
        const image = imageDataURL.replace("data:image/jpeg;base64,", "");
        await this.insertObjet(
          destName + ".pdf", ".pdf", +localStorage.getItem('idPatient'), image, 141, 200, 0, 0, null, 1, destName + ".pdf", "", Context.folder + localStorage.getItem('idPatient'), "", "", "", 0, localStorage.getItem('idPatient')
        ).toPromise();
        this.showSpinner = false;
        this.isDisabled = false;

      });
    });  

    var form = new FormData();
    form.append("file", blob);
    this.objetService
        .saveImage(destName + ".pdf", Context.folder + localStorage.getItem('idPatient'), form)
        .subscribe();
  }

    insertObjet(
    nom,
    extension,
    id_patient1,
    vignette,
    width,
    height,
    taille,
    estidentite,
    dateCreation,
    echelle,
    fichier,
    lastModif,
    repStockage,
    syncPath,
    dateInsertion,
    auteur,
    idGabarit,
    id_patient_orthalis
  ) {
    this.objets["nom"] = nom;
    this.objets["extension"] = extension;
    this.objets["id_patient"] = id_patient1;
    this.objets["vignette"] = vignette;
    this.objets["width"] = width;
    this.objets["height"] = height;
    this.objets["taille"] = taille;
    this.objets["estidentite"] = estidentite;
    this.objets["dateCreation"] = dateCreation;
    this.objets["echelle"] = echelle;
    this.objets["fichier"] = fichier;
    this.objets["lastModif"] = lastModif;
    this.objets["repStockage"] = repStockage;
    this.objets["syncPath"] = syncPath;
    this.objets["dateInsertion"] = dateInsertion;
    this.objets["auteur"] = auteur;
    this.objets["idGabarit"] = idGabarit;
    this.objets["id_patient_orthalis"] = id_patient_orthalis;

    return this.objetService.addObjet(this.objets);
  }

  isPaillette = false
  selectPaillette() {
    this.isPaillette = !this.isPaillette;
    console.log('ispaillete', this.isPaillette);
  }
}
function generateRandomString(length: number): string {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';

  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    result += characters.charAt(randomIndex);
  }

  return result;
}